module.exports = __webpack_public_path__ + "4f2a9464f87b46c689a3552230e517cf.svg";